<template>
  <cs-basic>
    <template v-slot:header>
      <login-header app="primeiroAcesso" />
    </template>
    <template v-slot:content>
      <component
        :is="action"
        :fullName="fullName"
        :token="token"
        :tokenValid="tokenValid"
      />
    </template>
    <template v-slot:footer>
      <login-footer />
    </template>
  </cs-basic>
</template>

<script>
import csBasic from "@/layouts/csBasic.vue";
import loginHeader from "@/components/header/loginHeader.vue";
import loginFooter from "@/components/loginFooter.vue";
import resendAccess from "@/components/firstAccess/resendAccess.vue";
import setPassword from "@/components/firstAccess/setPassword.vue";

export default {
  components: {
    csBasic,
    loginHeader,
    resendAccess,
    setPassword,
    loginFooter,
  },
  data() {
    return {
      email: "",
      token: "",
      action: "",
      tokenValid: true,
    };
  },
  async beforeCreate() {
    const token = this.$route.query.token;

    if (!token) {
      this.$router.push({ name: "NotFound" });
      return;
    }

    const urlToken = this.$store.state.global.baseUrl;
    const result = await this.$http.post(
      `${urlToken}/api/account/resolveactiontoken`,
      {
        token: token,
      }
    );

    if (result.status !== 200) {
      this.$router.push({ name: "NotFound" });
      return;
    }

    const { action, infos } = result.data.data;

    this.fullName = infos.Usuario;
    this.token = token;

    if (action === "FirstLogin") {
      this.action = "setPassword";
    } else {
      action == "SendEmail";
      this.tokenValid = false;
      this.action = "resendAccess";
    }
  },
};
</script>
